// related to rule details - single rule operations

import HttpServiceSingleton from '../HttpService/HttpService';

const API_BASE = process.env.REACT_APP_RULES_API ?? '';

export interface RuleRecommendationsListParams {
  page?: number;
  limit?: number;
  status?: number;
  type?: number;
}

export interface RuleCondition {
  objectName: string;
  operation: string;
  objectValue: string | string[];
}

export interface EntitlementMetaData {
  evKey: number;
  entitlementValueName: string;
  evDisplayName: string;
  evDescription: string | null;
  existingUserCount: number;
  trustScore: number;
  endpoint: {
    endpointKey: number;
    endpointName: string;
    endpointDisplayName: string | null;
    description: string | null;
    logo: string;
  };
  entitlementType: {
    entitlementTypeKey: number;
    entitlementTypeName: string;
    entitlementDisplayName: string;
    description?: string;
  };
}

export interface RuleAction {
  entitlementMetaData: EntitlementMetaData;
}

export interface RuleRecommendation {
  recommendedObjectKey: number;
  name: string;
  userMatchCount: number;
  includedUsers: number;
  impact: string;
  yearlyRequestVolume: number;
  // TODO: REVERT - Remove when backend uses yearlyRequestVolume
  monthlyRequestVolume?: number;
  entitlements: number;
  confidence: number;
  conditions: RuleCondition[];
  actions: RuleAction[];
  isNew: boolean;
}

export interface RuleRecommendationDetails {
  success: boolean;
  message: string;
  recommendedObjectKey: number;
  filters: Record<string, unknown>;
  result: {
    data: (RuleRecommendation & {
      description: string;
      comments?: string;
    })[];
    pagination: {
      nextPage: number;
      currentPage: number;
    };
  };
  userAccess: 'edit' | 'view' | 'none';
}

export interface RuleRecommendationsListResponse {
  data: RuleRecommendation[];
  pagination: {
    nextPage: string | null;
    currentPage: number;
  };
  userAccess?: 'edit' | 'view' | 'none';
}

const RuleRecommendationsService = {
  getRuleRecommendations(params: RuleRecommendationsListParams = {}) {
    const queryParams = new URLSearchParams();

    if (params.page) {
      queryParams.append('page', params.page.toString());
    }

    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    if (params.status) {
      queryParams.append('status', params.status.toString());
    }

    if (params.type) {
      queryParams.append('type', params.type.toString());
    }

    const queryString = queryParams.toString();
    const url = `${API_BASE}/ECMv6/api/intelligence/ruleRecommendations/rules${
      queryString ? `?${queryString}` : ''
    }`;

    return HttpServiceSingleton.get(url);
  },

  getRuleRecommendationDetails(recommendedObjectKey: number) {
    const url = `${API_BASE}/ECMv6/api/intelligence/ruleRecommendations/rules/${recommendedObjectKey}`;

    return HttpServiceSingleton.post(url);
  },
};

export default RuleRecommendationsService;
